import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

function Loader({ msg }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="90vh"
    >
      <CircularProgress className="loader" size={55} />
      <Typography variant="h6" className="loader-text">
        {msg || "Loading"}
        {"..."}
      </Typography>
    </Box>
  );
}

export default Loader;
